angular.module('alerts', ['pascalprecht.translate', 'alerts.templates']);
(function () {
  'use strict';

  angular
    .module('alerts')
    .factory('alertsService', alertsService);

  alertsService.$inject = ['$translate'];

  function alertsService($translate) {

    /**
     * Create an alert
     * @typedef {'error' | 'fielderror' | 'success' | 'warning' | 'info'} AlertType
     * @param {AlertType} type Alert type
     * @param {string} message Message of the alert
     * @param {string} [parameters] Translation parameters
     * @param  {string} [title] Title of the alert
     * @return {{ type: AlertType, messages: string[], title?: string }[]}
     */

    function getAlert(type, message, parameters, title) {
      const alert = {
        type,
        messages: [$translate.instant(message, parameters)]
      };
      if (title) {
        alert.title = $translate.instant(title);
      }
      return [alert];
    }

    return {
      /**
       * Function who create an alert of type error
       * @param  {String} message    Message of the alert
       * @param  {Array} parameters  Parameters of the message
       * @param  {String} title      (optional) Title of the alert
       * @return {Array}             Alerts
       */
      getAlertError: function (message, parameters, title) {
        return getAlert('error', message, parameters, title);
      },
      /**
       * [getAlertWarning description]
       * @param  {String} message    Message of the alert
       * @param  {Array} parameters  Parameters of the message
       * @param  {String} title      (optional) Title of the alert
       * @return {Array}             Alerts
       */
      getAlertWarning: function (message, parameters, title) {
        return getAlert('warning', message, parameters, title);
      },
      /**
       * [getAlertInfo description]
       * @param  {String} message    Message of the alert
       * @param  {Array} parameters  Parameters of the message
       * @param  {String} title      (optional) Title of the alert
       * @return {Array}             Alerts
       */
      getAlertInfo: function (message, parameters, title) {
        return getAlert('info', message, parameters, title);
      },
      /**
       * [getAlertSuccess description]
       * @param  {String} message    Message of the alert
       * @param  {Array} parameters  Parameters of the message
       * @param  {String} title      (optional) Title of the alert
       * @return {Array}             Alerts
       */
      getAlertSuccess: function (message, parameters, title) {
        return getAlert('success', message, parameters, title);
      }
    };
  }
})();

AlertsCenterDirective.$inject = ['$window', '$log', '$translate'];

function AlertsCenterDirective($window, $log, $translate) {
  'use strict';

  return {
    restrict: 'A',
    replace: true,
    transclude: false,
    templateUrl: 'alerts/alerts-directives/alerts-center/alerts-center.html',
    scope: {
      id: '=',
      alerts: '=?',
    },
    link: function (scope, element) {
      /**
       * Function who listen an evenement of type 'alerts'
       * @param  {[type]} event  Evenement
       * @param  {[type]} alerts Alerts to display
       * @param  {[type]} id     Od of an alerts directive
       */
      scope.$on('alerts', function (event, alerts, id) {
        if (id === null || id === scope.id) {
          scope.alerts = alerts;

          // Scroll to view alerts, including if we are integrated in an iframe
          if (alerts && alerts.length) {
            let parent;
            try {
              parent = $window.parent;
            } catch (e) {
              // Happens in case of cross domain iframe integration
            }

            if (!parent || parent === $window.self) {
              return $window.scrollTo(0, element.offset().top);
            }

            if (!$window.frameElement) {
              return $log.warning(
                'alertsService - Iframe element is not named, its offset can not be used to manage scroll'
              );
            }

            var globalOffset =
              $($window.frameElement).offset().top + element.offset().top;

            // 160 is arbitrary and corresponds mainly to the integration in portal-acteurs-eco
            parent.scrollTo(0, globalOffset - 160 > 0 ? globalOffset - 160 : 0);
          }
        }
      });

      scope.$on('hideAlerts', function () {
        scope.hide();
      });

      /**
       * Function who hide alerts
       */
      scope.hide = function () {
        scope.alerts = [];
      };

      /**
       * Return the mg-alert configuration
       * @param {object} alert
       * @returns {object} mg-alert configuration
       */
      scope.getMgAlertConfiguration = function (alert) {
        switch (alert.type) {
        case 'error':
          return {
            variant: 'danger',
            translation: alert.title || $translate.instant('alert.error'),
          };
        case 'success':
          return {
            variant: 'success',
            translation:
                alert.title || $translate.instant('alert.validation'),
          };
        case 'warning':
          return {
            variant: 'warning',
            translation: alert.title || $translate.instant('alert.warning'),
          };
        default:
          return { variant: 'info' };
        }
      };
    },
  };
}

angular.module('alerts').directive('alertsCenter', AlertsCenterDirective);

try {
  // ugly fix, this is needed for jest but throws error when running on ecmaScript 5 that
  // doesn't support modules
  exports.AlertsCenterDirective = AlertsCenterDirective;
  // eslint-disable-next-line no-empty
} catch (_ignored) {}

angular.module("alerts.templates", []).run(["$templateCache", function($templateCache) {$templateCache.put("alerts/alerts-directives/alerts-center/alerts-center.html","<div>\n  <div\n    class=\"alerts-center-message\"\n    ng-repeat=\"alert in alerts\"\n    ng-init=\"MgAlertConfiguration = getMgAlertConfiguration(alert)\"\n  >\n    <mg-alert\n      identifier=\"{{\'alert-\' + $index}}\"\n      ng-prop-variant=\"MgAlertConfiguration.variant\"\n    >\n      <strong ng-if=\"MgAlertConfiguration.translation\"\n        >{{MgAlertConfiguration.translation}}</strong\n      >\n      <p ng-repeat=\"message in alert.messages\" ng-bind-html=\"message\"></p>\n    </mg-alert>\n  </div>\n</div>\n");}]);